/**
 * React component that serves as a layout for "mini card".
 *
 * Copyright (c) 2020 Propellant Software Corp
 * Author: Yucho Ho
 */
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { Card, CardBody } from 'reactstrap'
import styles from './MiniCard.module.scss'

const MiniCard = ({
  className,
  header,
  image,
  footer,
  fluid,
  onClick,
  onMouseEnter,
  onMouseLeave,
  children
}) => {
  const coverImage = useMemo(() => {
    return (image) ? (
      <div className={cx(styles['img-container'], 'card-image')}>
        <div className={cx(styles['card-header'])}>
          {header}
        </div>
        {image}
      </div>
    ) : (
      <div className={cx(styles['card-header'])}>
        {header}
      </div>
    )
  }, [header, image])

  return (
    <Card
      className={cx(styles['card'], className, {
        [styles['fluid']]: !!fluid
      })}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}>
      {coverImage}
      <CardBody className={cx(styles['card-body'])}>
        {children}
        {footer && (
          <div className={cx(styles['footer'])}>
            {footer}
          </div>
        )}
      </CardBody>
    </Card>
  )
}

MiniCard.defaultProps = {
  size: 'sm'
}

MiniCard.propTypes = {
  className: PropTypes.string,
  header: PropTypes.node,
  image: PropTypes.oneOfType([PropTypes.node]),
  footer: PropTypes.node,
  fluid: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  children: PropTypes.node
}

export default MiniCard
